import { render, staticRenderFns } from "./Sella-back-error.vue?vue&type=template&id=13824fc1"
import script from "./Sella-back-error.vue?vue&type=script&lang=js"
export * from "./Sella-back-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports